import React from 'react';
import { Button, Space } from 'antd';

const LinkInvoiceQuoteButtons = ({ onLinkInvoice, onLinkQuote }) => (
  <Space style={{ marginBottom: 16 }}>
    <Button type="dashed" onClick={onLinkInvoice}>
      Link existing invoice
    </Button>
    <Button type="dashed" onClick={onLinkQuote}>
      Link existing quote
    </Button>
  </Space>
);

export default LinkInvoiceQuoteButtons;
